export const getPreviousAndUpcomingSunday = (date = new Date()) => {
  // Set the time to 0 to avoid daylight saving time issues
  date.setHours(0, 0, 0, 0);

  // If today is Sunday, set the previousSunday to today's date
  let previousSunday = new Date(date);
  previousSunday.setDate(date.getDate() - (date.getDay() || 7)); // If getDay() is 0 (Sunday), subtract 7 to keep it the same day

  // Get the upcoming Sunday by adding 7 days to the previous Sunday
  let upcomingSunday = new Date(previousSunday);
  upcomingSunday.setDate(upcomingSunday.getDate() + 7);

  return { previousSunday, upcomingSunday };
};
